import React from 'react';
import parkingimage from "../src/images/parkingimg.webp";
import lostandfound from "../src/images/lostandfound.webp";
import bustaxitrain from "../src/images/bustaxitrain.webp";
import foodloungerestaurant from "../src/images/food.webp";
import shopping from "../src/images/shopfinal.png";
import food from "../src/images/foodfinal.png";
import hotels from "../src/images/hotels.webp";
import perfume from "../src/images/perfume.jpg";
import coupon1 from "../src/images/f1.png";
import coupon2 from "../src/images/f3.png";
import dosa from "../src/images/dosa.jpg";
import { NavLink } from "react-router-dom";
import airport from "../src/images/logo.png";
import airlines from "../src/images/airlines.webp";
import Records from './Records.json'
import { TbPlaneTilt } from "react-icons/tb";
import {Helmet} from 'react-helmet-async';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import "bootstrap/dist/css/bootstrap.min.css";
import SwiperCore, {
  EffectCoverflow,
  Pagination,
  Navigation
} from "swiper/core";




SwiperCore.use([EffectCoverflow, Pagination, Navigation]);




const Home = () => {
  const images = [
    { src: food, link: '/restaurant' },
    { src: shopping, link: '/hotels' },
  ];
  
  return (
    <>
    <Helmet>
      <title>Home</title>
      <meta name='description' content="Coimbatore Airport All Services"/>
      <link rel="canonical" href="/"/>
    </Helmet>
    
      <section id="header">
        <div className="container-fluid nav_bg">
          <br/>
          <div className="row">
            <div className="col-12 mx-auto">
              <div className="row">
              {/* carousel will come here */}
              <Swiper
        navigation={true}
        effect={"coverflow"}
        centeredSlides={true}
        slidesPerView={window.innerWidth < 768 ? 1 : "auto"}
        loop={true}
        coverflowEffect={{
          rotate: 100,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }}
        pagination={{
          clickable: true
        }}
        className="mySwiper"
      >
        <SwiperSlide>
          <img className="sliderimage" src={coupon1} />
        </SwiperSlide>
        <SwiperSlide>
          <img className="sliderimage" src={coupon2} />
        </SwiperSlide>
        <SwiperSlide>
          <img className="sliderimage" src="https://swiperjs.com/demos/images/nature-3.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img className="sliderimage" src="https://swiperjs.com/demos/images/nature-4.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img className="sliderimage" src="https://swiperjs.com/demos/images/nature-5.jpg" />
        </SwiperSlide>
        <SwiperSlide>
          <img className="sliderimage" src="https://swiperjs.com/demos/images/nature-6.jpg" />
        </SwiperSlide>
      </Swiper>
              </div>
            </div>
          </div>
        </div>

        <div className="my-5">
          <h1 className="text-center fw-bolder">SERVICES</h1>
        </div>

        <div className="image-links">
      {images.map((image, index) => (
        <NavLink to={image.link} key={index} className="btn btnmenu btn-primary">
            
          <button variant="link" className="rounded-circle p-0 m-0">
            <img src={image.src} alt={`Image ${index + 1}`} width="200" height="200" />
          </button>
          </NavLink>
      ))}
    </div>

        <div className="my-5">
          <h1 className="text-center">BEST SELLERS</h1>
          <div className="container-fluid mb-5">
            <div className="row">
              <div className="col-10 mx-auto">
                <div className="row gy-4">


                  <div className="col-md-4 col-10 mx-auto">
                    <div className="card">
                      <img src={perfume} className="card-img-top img-thumbnail img-responsive" alt="lost and found" />
                      <div className="card-body">
                        <h5 className="card-title">Perfume</h5>
                        <p className="card-text">
                          Best Perfume with Price 200/-
                        </p>
                        <NavLink to="/lostandfound" className="btn btn-primary">
                          More Info...
                        </NavLink>
                      </div>
                    </div>
                    </div>
                    <br/>
                  

                      <div className="col-md-4 col-10 mx-auto">
                    <div className="card">
                      <img src={dosa} className="card-img-top img-thumbnail img-responsive" alt="bus taxi train" />
                      <div className="card-body">
                        <h5 className="card-title">Dosa</h5>
                        <p className="card-text">
                        Dosa starting with 100 Rs
                        </p>
                        <NavLink to="/transport" className="btn btn-primary">
                          More Info...
                        </NavLink>
                      </div>
                    </div>
                    </div>
                    <br/>


                    
                    
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
